import { ReactNode } from "react";

import { confirmDialog, ConfirmDialogProps } from "primereact/confirmdialog";
import { IconType } from "primereact/utils";

import { faExclamationTriangle } from "@fortawesome/pro-regular-svg-icons";

import { translationKeys } from "../../../../models/app-translation-keys";
import { Icon } from "../../Icon/Icon";

interface IConfirmActionDialogProps {
  header?: string;
  message?: string | ReactNode;
  acceptLabel?: string;
  rejectLabel?: string;
  acceptClassName?: string;
  rejectClassName?: string;
  icon?: IconType<ConfirmDialogProps>;
  hideIcon?: boolean;
  defaultFocus?: "accept" | "reject";
  closeOnEscape?: boolean;
  dismissableMask?: boolean;
}

export const confirmAction = async (
  t: (key: string) => string,
  props?: IConfirmActionDialogProps,
): Promise<boolean> => {
  const confirmTranslationKeys = translationKeys.dialog.confirm;

  return new Promise(resolve => {
    confirmDialog({
      header: props?.header || t(confirmTranslationKeys.header),
      message: props?.message || t(confirmTranslationKeys.message),
      icon: !props?.hideIcon && (props?.icon || <Icon icon={faExclamationTriangle} />),
      defaultFocus: props?.defaultFocus ?? "reject",
      acceptClassName: props?.acceptClassName ?? "p-button-danger",
      rejectClassName: props?.rejectClassName,
      acceptLabel: props?.acceptLabel || t(confirmTranslationKeys.acceptLabel),
      rejectLabel: props?.rejectLabel || t(confirmTranslationKeys.rejectLabel),
      closeOnEscape: props?.closeOnEscape,
      dismissableMask: props?.dismissableMask,
      accept: () => resolve(true),
      reject: () => resolve(false),
    });
  });
};
